<template>
  <page-outline :title="$t('mandate.details_collection')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="min-w-100 justify-content-start align-items-center">
          <b-col cols="12" class="d-flex justify-content-start mt-3">
            <back-button class="btnFilter_2 mr-2" :returnUrl="returnUrl"></back-button>
            <b-button class="back-button btnFilter_2" @click="getCollection()" >
              <i class="fa-solid fa-rotate-right"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <br></br>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="listItemsCollection.length > 0">
          <b-row class="justify-content-center">
            <b-col cols="12" class="mt-3">
              <div>
                <form-accordion :title="$t('mandate.mandate_info')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.unique_mandate_rf')" :inputValue="listItemsCollection[0].UMR || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.mandate_type')" :inputValue="$t('mandate.mandate_type_' + listItemsCollection[0].TypeMandate) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.sign_mandate_date')" :inputValue="formatDateShort(listItemsCollection[0].SigningMdDate) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div>
                <form-accordion :title="$t('mandate.details_transactions')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.status_collection')" :inputValue="$t('mandate.status_collection_' + listItemsCollection[0].Status) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.end_to_end_id')" :inputValue="listItemsCollection[0].EndToEndId || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.schema_code')" :inputValue="listItemsCollection[0].SchemaCode || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.collection_type')" :inputValue="$t('mandate.collection_type_' + listItemsCollection[0].TypeTransaction) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.amt')" :inputValue="formatCurrency(listItemsCollection[0].Amount) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.date_due')" :inputValue="formatDateShort(listItemsCollection[0].DueDate) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.date_settlement')" :inputValue="formatDateShort(listItemsCollection[0].SettlementDate) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.date_debit')" :inputValue="formatDateShort(listItemsCollection[0].DebitDate) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_ref')" :inputValue="listItemsCollection[0].CdtrRefCollection || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.purpose')" :inputValue="listItemsCollection[0].Purpose || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.purpose_category')" :inputValue="listItemsCollection[0].PurposeCategory || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.remittance_info')" :inputValue="listItemsCollection[0].RemittanceInfo || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <!--
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.direction_collection')" :inputValue="$t('mandate.direction_collection_' + listItemsCollection[0].Direction) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    -->
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.rsn_mandate_amendment')" :inputValue="listItemsCollection[0].ReasonMandate || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.reject_reason')" :inputValue="listItemsCollection[0].RejectionReason || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.reject_code')" :inputValue="listItemsCollection[0].RejectionCode || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div>
                <form-accordion :title="$t('mandate.cdtr_info')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_name')" :inputValue="listItemsCollection[0].CdtrName !== '$NotFound' ? listItemsCollection[0].CdtrName : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_id')" :inputValue="listItemsCollection[0].CdtrId !== '$NotFound' ? listItemsCollection[0].CdtrId : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_addrss')" :inputValue="listItemsCollection[0].CdtrAddr !== '$NotFound' ? listItemsCollection[0].CdtrAddr : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_city')" :inputValue="listItemsCollection[0].CdtrCity !== '$NotFound' ? listItemsCollection[0].CdtrCity : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_ctry')" :inputValue="listItemsCollection[0].CdtrCountry !== '$NotFound' ? listItemsCollection[0].CdtrCountry : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_rf_pty_id_cd')" :inputValue="listItemsCollection[0].CdtrRef !== '$NotFound' ? listItemsCollection[0].CdtrRef : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_rf_pty_nm')" :inputValue="listItemsCollection[0].CdtrRefName !== '$NotFound' ? listItemsCollection[0].CdtrRefName : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_iban')" :inputValue="listItemsCollection[0].CdtrIBAN !== '$NotFound' ? listItemsCollection[0].CdtrIBAN : '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                    <!--
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.cdtr_pspbic')" :inputValue="listItemsCollection[0].CdtrPSPBIC !== '$NotFound' ? listItemsCollection[0].CdtrPSPBIC : '-'">
                      </form-read-group-label-input>
                      -->
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div>
                <form-accordion :title="$t('mandate.dbtr_info')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.dbtr_name')" :inputValue="listItemsCollection[0].DbtrName || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.dbtr_iban')" :inputValue="listItemsCollection[0].DbtrIBAN || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                    <!--
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.dbtr_pspbic')" :inputValue="listItemsCollection[0].DbtrPSPBIC || '-'">
                      </form-read-group-label-input>
                      -->
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div class="history-no-padding">
                <form-accordion :title="$t('mandate.history')" :isTitleUpperCase="false">
                  <table class="table table-striped w-100" v-if="listItemsCollection.length > 0">
                    <tbody>
                    <tr>
                      <th class="text-center w-25">
                        {{ $t('mandate.status_collection') }}
                      </th>
                      <th class="text-center w-25">
                        {{ $t('mandate.date_action') }}
                      </th>
                    </tr>
                    <tr v-for="c in listItemsCollection[0].History">
                      <td class="text-center w-25">
                        <div :class="['chip','chip--' + statusVariant(c.StatusHistory)]">{{ $t('mandate.status_collection_' + c.StatusHistory) || '-' }}</div>
                      </td>
                      <td class="text-center w-25">
                        <div>{{ formatDate(c.ActionDate) || '-' }}</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </form-accordion>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="['7'].includes(listItemsCollection[0].Status)" class="form-group justify-content-end mt-5">
            <b-col lg="2">
              <b-button variant="primary" size="lg"
                @click="editStatusReversal">
                <i class="fa-solid fa-turn-down-right" size="17px"></i>
                <span>{{ $t('mandate.reverse') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";
import {errorMessageAlert} from "@/helpers/alert"

export default {
  name: 'MandateTransactionsDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
  },
  data () {
    return {
      activateSpinner: false,
      listItemsCollection: []
    }
  },
  created () {
    this.IdCollection = this.$route.params.idCollection
    this.IdCollectionBulk = this.$route.query.IdCollectionBulk

    if (this.IdCollectionBulk !== undefined) {
      this.returnUrl = '/mandatetransactionsbulk/details/' + this.IdCollectionBulk + '?IdCollectionBulk=' + this.IdCollectionBulk
    } else {
      this.returnUrl = '/mandatetransactions/unit'
    }

    this.getCollection()

    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$t('common.entity_account.entity_account_details'),
    })

    this.$f7.initPullToRefresh()
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    editStatusReversal () {
      let that = this
      this.$f7.modal({
        title: this.$t('mandate.element_reverse_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdCollection: that.IdCollection,
                status: 9
              }
              that.$engine.Collection.editCollection(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('mandate.collection_cancelled'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                that.editMode = false
                that.getCollection()
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('mandate.cancel_error_collection'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    formatCurrency (n) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
    },
    formatDate(dateIso) {
      return dateIso.replace("T", " ")
    },
    formatDateShort (dateIso) {
      if (!dateIso) return ""
      const s = String(dateIso)
      // si format ISO : "YYYY-MM-DDTHH:mm:ss"
      if (s.includes("T")) {
        return s.split("T")[0]
      }
      // sinon on renvoie la chaîne telle quelle
      return s
    },
    getCollection() {
      this.activateSpinner = true
      let that = this
      let params = {
        IdCollection: this.IdCollection,
        IdCollectionBulk: this.IdCollectionBulk
      }

      this.$engine.Collection.getCollectionDetails(params).then((resp) => {

        let CollectionList = {}

        CollectionList = resp.data.Collection

        that.updateCollection(CollectionList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    statusVariant(status) {
      const map = {
        1: 'warning',
        2: 'success',
        3: 'danger',
        4: 'secondary',
        5: 'info',
        6: 'danger',
        7: 'success',
        8: 'warning',
        9: 'secondary',
        10: 'info'
      }
      return map[status] || 'secondary'
    },
    updateCollection(CollectionList) {
      this.listItemsCollection = CollectionList
    }
  }
}
</script>
<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
